import { MatchFunction } from 'path-to-regexp';

export const pathMatchPage = <T>(
	path: string,
	documents: PageWithMatchers<T>[]
): PageWithMatchers<T> | null => {
	for (const document of documents) {
		for (const matcher of document.matchers) {
			const result = matcher(path);

			if (result) {
				return document;
			}
		}
	}

	return null;
};

export type PageWithMatchers<T> = T & {
	matchers: MatchFunction<Record<string, string | undefined>>[];
};
